/** Web OAuth client IDs (public). Configure in Apple / Google developer consoles. */

export function getGoogleOAuthClientId(): string {
  return (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
}

export function getAppleOAuthClientId(): string {
  return (process.env.REACT_APP_APPLE_CLIENT_ID || '').trim();
}

/** Apple Sign In redirect URI must match an entry on the Services ID. */
export function getAppleRedirectUri(): string {
  if (typeof window === 'undefined') {
    return 'https://visime.com/';
  }
  const origin = window.location.origin;
  return origin.endsWith('/') ? origin : `${origin}/`;
}
